import { helmetData } from '@client-portal-utils/helmetData'
import { useBrandedTitleTemplate, useDefaultBrandedTitle } from '@client-portal-utils/hooks/useBrandedTitleTemplate'
import { Helmet } from 'react-helmet-async'
import { Outlet, ScrollRestoration } from 'react-router-dom'

import { MobileErrorBoundary, PageTracker } from '@acre/design-system'

const AppRoutes = () => {
  const titleTemplate = useBrandedTitleTemplate()
  const defaultTitle = useDefaultBrandedTitle()

  return (
    <PageTracker helmetData={helmetData}>
      <Helmet defer={false} titleTemplate={titleTemplate} defaultTitle={defaultTitle} helmetData={helmetData} />
      <MobileErrorBoundary>
        <Outlet />
        <ScrollRestoration />
      </MobileErrorBoundary>
    </PageTracker>
  )
}

export default AppRoutes
